// extracted by mini-css-extract-plugin
export default {"NavLink":"NavLink_NavLink__o9aeY","Active":"NavLink_Active__U5oCM","Gold":"NavLink_Gold__q6IpA"};